import EmbeddedAnalyticsTaskService from 'services/task/subServices/embeddedAnalyticsTask/EmbeddedAnalyticsTaskService';

export default {
	'services.embeddedAnalyticsTaskService': {
		class: EmbeddedAnalyticsTaskService,
		deps: [{ $ref: 'services.taskStateService' }],
	},
};
